import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminOrderService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiURL}/admin/orders`;

  getOrders(filters?: {
    status?: string;
    restaurantId?: number;
    date?: string;
    page?: number;
    size?: number;
  }): Observable<any> {
    let params = new HttpParams();

    if (filters) {
      if (filters.status) params = params.set('status', filters.status);
      if (filters.restaurantId) params = params.set('restaurantId', filters.restaurantId.toString());
      if (filters.date) params = params.set('date', filters.date);
      if (filters.page !== undefined) params = params.set('page', filters.page.toString());
      if (filters.size) params = params.set('size', filters.size.toString());
    }

    return this.http.get(this.apiUrl, {params});
  }

  getOrderById(id: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/${id}`);
  }

  updateOrderStatus(orderId: number, status: string): Observable<any> {
    return this.http.patch(`${this.apiUrl}/${orderId}/status`, {status});
  }

  cancelOrder(orderId: number, reason: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/${orderId}/cancel`, {reason});
  }

  assignDelivery(orderId: number, deliveryPersonId: number): Observable<any> {
    return this.http.post(`${this.apiUrl}/${orderId}/assign-delivery`, {deliveryPersonId});
  }

  getOrderStats(period: string = 'today'): Observable<any> {
    return this.http.get(`${this.apiUrl}/stats`, {
      params: new HttpParams().set('period', period)
    });
  }

  exportOrders(filters?: any): Observable<Blob> {
    let params = new HttpParams();
    if (filters) {
      Object.keys(filters).forEach(key => {
        if (filters[key]) {
          params = params.set(key, filters[key].toString());
        }
      });
    }

    return this.http.get(`${this.apiUrl}/export`, {
      params,
      responseType: 'blob'
    });
  }

  refundOrder(orderId: number, amount?: number): Observable<any> {
    return this.http.post(`${this.apiUrl}/${orderId}/refund`, {amount});
  }
}

